export const CHARACTERS = {
  testCharacter: {
    prototypeId: 'testCharacter',
    name: 'Test Character',
    spriteId: 'testCharacter'
  },
  reina: {
    prototypeId: 'reina',
    name: 'Reina',
    spriteId: 'reina'
  },
  eric: {
    prototypeId: 'eric',
    name: 'Eric',
    spriteId: 'eric'
  },
  mia: {
    prototypeId: 'mia',
    name: 'Mia',
    spriteId: 'mia'
  },
  james: {
    prototypeId: 'james',
    name: 'James',
    spriteId: 'james'
  },
  barista: {
    prototypeId: 'barista',
    name: 'Barista',
    spriteId: 'barista'
  },
  teammate: {
    prototypeId: 'teammate',
    name: 'Teammate',
    spriteId: 'teammate'
  },
  woman: {
    prototypeId: 'woman',
    name: 'Woman',
    spriteId: 'woman'
  }
}

export const LOCATIONS = {
  baliBeach: {
    name: 'Bali Beach',
    spriteId: 'baliBeach'
  },
  baliCafe: {
    name: 'Bali Cafe',
    spriteId: 'baliCafe'
  },
  baliVilla: {
    name: 'Bali Villa',
    spriteId: 'baliVilla'
  },
  cityStreet: {
    name: 'City Street',
    spriteId: 'cityStreet'
  },
  hotelRoom: {
    name: 'Hotel Room',
    spriteId: 'hotelRoom'
  },
  riverbank: {
    name: 'Riverbank',
    spriteId: 'riverbank'
  },
  baliOffice: {
    name: 'Bali Office',
    spriteId: 'baliOffice'
  },
  baliHill: {
    name: 'Bali Hill',
    spriteId: 'baliHill'
  },
  baliBar: {
    name: 'Bali Bar',
    spriteId: 'baliBar'
  },
  newCafe: {
    name: 'New Cafe',
    spriteId: 'newCafe'
  },
  airplane: {
    name: 'Airplane',
    spriteId: 'airplane'
  },
  ericsApartment: {
    name: 'Eric\'s Apartment',
    spriteId: 'ericsApartment'
  },
  ericsApartmentOutside: {
    name: 'Outside Eric\'s Apartment',
    spriteId: 'ericsApartmentOutside'
  }
}
